import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import LocalidadEntregaEdit from '../../components/LocalidadEntrega/localidadEntregaNuevo';
import { sagaSaveLocalidadEntrega, sagaGetLocalidadEntrega } from '../../reducers/localidadesEntregaReducer/actions';
import { localidadesEntregaEditSelector } from '../../selectors/localidadesEntregaSelector';
import { usuarioSelector, instalacionSelector } from '../../selectors/sessionSelector';
import * as Notification from '../../components/Common/notification';
import MyDialog from '../../components/Layout/myDialog';

class LocalidadEntregaEditContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            localidad: {
                idLocalidadEntrega: 0,
                nombre: '',
                descripcion: '',
                estado: true,
            },
            error: null,
            modalData: {
                openModal: false,
                mensaje: "¿Está seguro que desea desactivar esta localidad de entrega?",
                labelModalOk: "Desactivar",
                handleModalOk: () => {},
                handleCloseModal: () => {},
            },
            previousState: true, // guardo state anterior del Switch de Estado
        };
    }

    componentDidMount() {
        const { match: { params } } = this.props;
        if (params.idLocalidadEntrega && params.idLocalidadEntrega !== '0') {
            this.props.sagaGetLocalidadEntrega(params.idLocalidadEntrega);
        } else {
            this.setState({
                localidad: {
                    idLocalidadEntrega: 0,
                    nombre: '',
                    descripcion: '',
                    estado: true,
                },
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.localidad !== this.props.localidad) {
            const nuevaLocalidad = this.props.localidad.localidad;
            this.setState({ 
                localidad: nuevaLocalidad,
                previousState: nuevaLocalidad ? nuevaLocalidad.estado : true,                
            });
        }
    }

    capitalizeText = (text) => {
        if (!text) return '';
        return text.replace(/\w\S*/g, (word) => {
            return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
        });
    }

    isValidNombreMayusculas = (nombre) => {
        return /^[A-Z0-9_-]+$/.test(nombre);
    }

    handleOnChange = (e) => {
        const { name, value } = e.target;

        // Si se cambia el estado a false, abrir el modal de confirmación
        if (name === 'estado' && value === false && this.state.previousState === true) {
            this.showDesactivarConfirmacion();
            return;
        }

        // Formateo especial según campo
        let formattedValue = value;

        if (name === 'nombre') {
            formattedValue = value.toUpperCase().replace(/\s+/g, '');
        } else if (name === 'descripcion') {
            formattedValue = this.capitalizeText(value);
        }

        this.setState((prevState) => ({
            localidad: {
                ...prevState.localidad,
                [name]: formattedValue,
            },
            previousState: name === 'estado' ? value : prevState.previousState,
        }));
    }

    showDesactivarConfirmacion = () => {
        this.setState({ 
            modalData: {
                openModal: true,
                mensaje: `Está por desactivar la localidad de entrega "${this.state.localidad.descripcion}". Esto puede ocasionar inconvenientes con los turneros y posibles pedidos generados por los clientes. ¿Está seguro de continuar?`,
                labelModalOk: "Desactivar",
                handleModalOk: () => {
                    // Confirmar desactivación
                    this.setState((prevState) => ({
                        localidad: {
                            ...prevState.localidad,
                            estado: false,
                        },
                        previousState: false,
                        modalData: {
                            ...prevState.modalData,
                            openModal: false,
                        }
                    }));
                },
                handleCloseModal: () => {
                    // Cancelar desactivación: mantengo el estado anterior
                    this.setState((prevState) => ({
                        modalData: {
                            ...prevState.modalData,
                            openModal: false,
                        }
                    }));
                },
            }
        });
    }

    handleOnSave = () => {
        const { nombre, idLocalidadEntrega, descripcion } = this.state.localidad;
        let error = {};
        let hasError = false;

        if (!nombre) {
            error.nombre = "El nombre de la localidad es requerido";
            hasError = true;
        } else if (!this.isValidNombreMayusculas(nombre)) {
            error.nombre = "El nombre de la localidad debe estar en mayúsculas y sin espacios";
            hasError = true;
        }

        if (!descripcion) {
            error.descripcion = "La descripción es requerida";
            hasError = true;
        }

        if (hasError) {
            this.setState({ error });
            Notification.showError("Error al guardar la localidad de entrega", error);
            return;
        }

        try {
            this.props.sagaSaveLocalidadEntrega({ 
                ...this.state.localidad,
                idLocalidadEntrega: idLocalidadEntrega,
                idInstalacion: this.props.instalacion.id
            });
            
            // Mostrar notificación de éxito según si es creación o edición
            const mensaje = idLocalidadEntrega === 0 
                ? "Localidad de entrega creada correctamente" 
                : "Localidad de entrega actualizada correctamente";
            Notification.showSuccess(mensaje);
            
            // Navegar a la lista de localidades de entrega después de guardar
            setTimeout(() => {
                this.props.history.replace('/LocalidadesEntrega');
            }, 800);
        } catch (error) {
            Notification.showError("Error al guardar la localidad de entrega", error);
        }
    }

    render() {
        return (
            <>
                <LocalidadEntregaEdit 
                    entidad="Localidad de Entrega"
                    localidad={this.state.localidad}
                    handleOnChange={this.handleOnChange}
                    handleOnSave={this.handleOnSave}
                    handleOnCancel={() => this.props.history.push('/LocalidadesEntrega/')}
                    error={this.state.error}
                />

                {this.state.modalData.openModal && (
                    <MyDialog
                        cuerpo={this.state.modalData.mensaje}
                        botonConfirmar={this.state.modalData.labelModalOk}
                        handleOnConfirmar={this.state.modalData.handleModalOk}
                        handleOnCancelar={this.state.modalData.handleCloseModal}
                    />
                )}
            </>
        );
    }
};

LocalidadEntregaEditContainer.propTypes = {
    localidad: PropTypes.object,
    usuario: PropTypes.object,
    instalacion: PropTypes.object,
    sagaSaveLocalidadEntrega: PropTypes.func.isRequired,
    sagaGetLocalidadEntrega: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    localidad: localidadesEntregaEditSelector(state),
    usuario: usuarioSelector(state),
    instalacion: instalacionSelector(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    sagaSaveLocalidadEntrega,
    sagaGetLocalidadEntrega,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LocalidadEntregaEditContainer);